import React, { Fragment } from "react";
import Header from "../../Layout/Header";
import classes from '../../Home/Home.module.css'

export const RightPart = ({ children }) => {
    return (
        <div className={classes.homeRight}>
            <Header />
            {children}
        </div>
    )
}